import MobileDetect from "mobile-detect";
import {
  mobileGoogleAppUrl,
  mobileAppleAppUrl,
  mobileAppleStoreUrl,
  mobileFallbackUrl
} from "@/common/config";

const mobileDetect = new MobileDetect(window.navigator.userAgent);

export function isMobile() {
  return mobileDetect.mobile();
}

export function isPhone() {
  return mobileDetect.phone();
}

export function isTablet() {
  return mobileDetect.tablet();
}

export function isGoogle() {
  return mobileDetect.os() === "AndroidOS";
}

export function isApple() {
  const os = mobileDetect.os();

  return os === "iOS" || os === "iPadOS";
}

export function googleAppUrl() {
  return mobileGoogleAppUrl;
}

export function appleAppUrl() {
  return mobileAppleAppUrl;
}

export function appleStoreUrl() {
  return mobileAppleStoreUrl;
}

export function fallbackUrl() {
  return mobileFallbackUrl;
}
